import { render, staticRenderFns } from "./PartidaequipamientoQuickEditForm.vue?vue&type=template&id=32737dca"
import script from "./PartidaequipamientoQuickEditForm.vue?vue&type=script&lang=js"
export * from "./PartidaequipamientoQuickEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports